// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1061) return "static/chunks/1061-a3d5bd2115347308.js";
	if (chunkId === 7136) return "static/chunks/7136-ad5034ede2fc8f85.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"922":"7a28253f8f232f0d","1297":"639b7df5b143082c","1380":"0a1ad01c6620cd04","4074":"266c0b0c4e211541","4286":"725b16bae145c9b0","5287":"27e6d9670729fc1e","5357":"2b953a8e25e9a611"}[chunkId] + ".js";
};